import { CircularProgress, defaultColors } from '@zeptonow/zui';
import { Suspense, useMemo } from 'react';
import { Route } from 'react-router-dom';
import { FaroRoutes } from '@zeptonow/hawkeye';
import ErrorBoundary from '../component/error-boundary';
import NotFound from '../component/NotFound';
import getModuleRoutes from './ModuleRoutes';
import renderModuleRoutes from './renderModuleRoutes';

function AppRoutes() {
  const routes = useMemo(() => getModuleRoutes(), []);

  return (
    <ErrorBoundary>
      <Suspense
        fallback={
          <div className="relative h-[calc(100vh-4rem)] z-0">
            <CircularProgress
              isOpen
              isBackdropVisible
              color={defaultColors.primary[800]}
              className="!absolute !bg-[rgba(50,50,50,0.25)]"
            />
          </div>
        }
      >
        <FaroRoutes>
          {renderModuleRoutes(routes)}
          <Route path="*" element={<NotFound />} />
        </FaroRoutes>
      </Suspense>
    </ErrorBoundary>
  );
}

export default AppRoutes;
